import { DownloadSimpleIcon, FileIcon } from '@phosphor-icons/react';
import React from 'react';

import { Button } from '../../../../components/button/Button';
import { useDownloadDocument } from '../../../document/hooks/useDownloadDocument';

interface ComplaintAttachmentsListProps {
  complaintId: string;
  attachments?: Array<{
    id: string;
    document: {
      id: string;
      name: string;
      hash: string;
    };
  }>;
}

export const ComplaintAttachmentsList: React.FC<ComplaintAttachmentsListProps> = ({
  complaintId,
  attachments = [],
}) => {
  const { downloadFile, downloadingFiles } = useDownloadDocument();

  // If no attachments, don't render anything
  if (attachments.length === 0) {
    return null;
  }

  return (
    <div className="border-t border-border pt-3 mt-3">
      <div className="text-sm font-medium text-fg-secondary mb-2 flex items-center">
        <FileIcon className="w-4 h-4 mr-1" />
        Bijlagen ({attachments.length})
      </div>

      <div className="space-y-1">
        {attachments.map((attachment) => (
          <div key={attachment.id} className="flex items-center justify-between bg-surface-sunken rounded px-3 py-2">
            <div className="flex items-center flex-1">
              <FileIcon className="w-4 h-4 text-fg-muted mr-2 shrink-0" />
              <span className="text-sm text-fg-secondary truncate">{attachment.document.name}</span>
            </div>

            <Button
              color="secondary"
              onTrigger={() => downloadFile(attachment.document)}
              isLoading={downloadingFiles.includes(attachment.document.id)}
            >
              <DownloadSimpleIcon className="w-4 h-4" />
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};
